import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from "@ngxs/store";
import { minutesToMilliseconds } from "date-fns";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule],
  template: `
    <router-outlet></router-outlet>`
})
export class AppComponent implements OnInit {

  private store = inject(Store);

  ngOnInit() {

  }
}
